// Finnish business id (Y-tunnus) format and check digit. CommonJS on purpose:
// the client validators import it and the server (services/prh.js, the
// invoicing endpoints) requires it. Keep this file free of imports.
//
// Check digit: modulus 11 with weights 7,9,10,5,8,4,2.
// https://www.vero.fi/yritykset-ja-yhteisot/tietoa-yritysverotuksesta/perustietoa-yrittajalle/y-tunnus/
const YTUNNUS_RE = /^\d{7}-\d$/;
const YTUNNUS_WEIGHTS = [7, 9, 10, 5, 8, 4, 2];

const isValidYtunnus = value => {
  if (typeof value !== 'string' || !YTUNNUS_RE.test(value)) return false;
  const [digits, check] = value.split('-');
  let sum = 0;
  for (let i = 0; i < YTUNNUS_WEIGHTS.length; i += 1) {
    sum += parseInt(digits[i], 10) * YTUNNUS_WEIGHTS[i];
  }
  const remainder = sum % 11;
  if (remainder === 1) return false; // no valid check digit exists
  const expected = remainder === 0 ? 0 : 11 - remainder;
  return expected === parseInt(check, 10);
};

module.exports = { YTUNNUS_RE, isValidYtunnus };
